export default __webpack_public_path__ + "static/media/logo.987db83b.svg";